/* unplugin-vue-components disabled */import script from "./AdminRoleProvider.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminRoleProvider.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./AdminRoleProvider.vue?vue&type=style&index=0&id=6a5524a8&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__